import React from 'react'
import Dropdown from './dropdown'
import Spacer from './spacer'
export default function Process({ processes }) {
    return (
        <div>
            <h1 className='text-center text-light m0  lh-07 sm '>Our <br /> Process</h1>
            <Spacer />
            <div className=' max-1200 ma bb1'>
                {processes.map(({ name, description }, index) => {
                    return (
                        <Dropdown key={index} headerClassName='w-100' header={<Header name={name} />}>
                            <div className='grid-cols-2 grid pb100 pt60 '>
                                <div />
                                <div className='max-400 text-light small lh-135'>
                                    {description}
                                </div>
                            </div>
                        </Dropdown>
                    )
                })}
            </div>
        </div>
    )
}


function Header({ name }) {
    return (
        <div className='pt10 pb10 with-dot-after  w-100 flex justify-between text-light bt1 uppercase'>
            {name}
        </div>
    )
}